import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { selectUnreadCount } from 'src/app/store/counter.selectors';
import { CommonModule } from '@angular/common';
import { ChatService } from 'src/app/service/chat.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: true,
    imports: [RouterModule, CommonModule]
})
export class FooterComponent implements OnInit, OnDestroy {
  unreadCount$: Observable<number>;
  isChatOpenMobile: boolean = false;
  private chatOpenSub?: Subscription;

  constructor(
    public router: Router,
    private store: Store,
    private chatService: ChatService,
    private cdRef: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this.unreadCount$ = this.store.select(selectUnreadCount);
    this.chatOpenSub = this.chatService.isChatOpenMobile$.subscribe(isOpen => {
      this.isChatOpenMobile = isOpen;
      this.cdRef.markForCheck();
    });
  }

  public ngOnDestroy(): void {
    if (this.chatOpenSub) {
      this.chatOpenSub.unsubscribe();
    }
  }

  get version(): string {
    return localStorage.getItem('version') || 'V3';
  }

  public shouldDisplay(): boolean {
    const hiddenRoutes = ['login', 'registration', 'video-call'];
    if (hiddenRoutes.some(route => this.router.url.includes(route))) {
      return false;
    }

    if (this.isChatOpenMobile) {
      return false;
    }

    const url = this.router.url;
    const path = window.location.pathname;
    const isSpecificChatUrl = (url.startsWith('/main-chat/') && url !== '/main-chat/' && url !== '/main-chat') ||
                              (path.startsWith('/main-chat/') && path !== '/main-chat/' && path !== '/main-chat');

    if (isSpecificChatUrl) {
      return false;
    }

    return true;
  }

  public isHome(): boolean {
    const url = this.router.url;
    return url === '/home' || url.startsWith('/home?') || url.startsWith('/home#');
  }

  public isLeadTrack(): boolean {
    return this.router.url.includes('/lead-track');
  }

  public toggleLeadTrackMenu(): void {
    this.chatService.triggerToggleLeadTrackMenu();
  }
}

